import { Option, none, isNone, some } from 'fp-ts/lib/Option';
import Layout from 'domain/entity/layout';

interface UpdateLayoutCriteria {
    dashboardId: string;
    layout: Layout;
}

class UpdateLayoutCriteriaImpl implements UpdateLayoutCriteria {
    constructor(readonly dashboardId: string, readonly layout: Layout) {}
}

export class UpdateLayoutCriteriaBuilder {
    private dashboardId: Option<string> = none;

    private layout: Option<Layout> = none;

    static create = (): UpdateLayoutCriteriaBuilder => new UpdateLayoutCriteriaBuilder();

    withDashboardId = (dashboardId: string): UpdateLayoutCriteriaBuilder => {
        this.dashboardId = some(dashboardId);

        return this;
    };

    withLayout = (layout: Layout): UpdateLayoutCriteriaBuilder => {
        this.layout = some(layout);

        return this;
    };

    build = (): UpdateLayoutCriteria => {
        if (isNone(this.dashboardId) || isNone(this.layout)) {
            throw new ReferenceError('Undefined prop');
        }

        return new UpdateLayoutCriteriaImpl(this.dashboardId.value, this.layout.value);
    };
}

export default UpdateLayoutCriteria;
